import 'console-polyfill';
import 'core/polyfill/polyfill';
import Core          from '../core';
import cookies       from 'browser-cookies';
import axios         from 'axios';
import EventManager  from 'dd-event-manager';

const core = new Core('bc-segments');
const segments = ['Device', 'UserType', 'SchoolChoices', 'Scores'];
const segmentClasses = segments.map(name => {
  return {
    name       : name.charAt(0).toLowerCase() + name.slice(1),
    className  : name,
    constructor: require(`./segments/${name}`).default,
  };
});

const COOKIE_EXPIRES   = 365;
const GLOBAL_SUFFIX    = 'bcs_';
const CONFIG_FILE_NAME = 'config.json';
const WATCH_INTERVAL   = 250;



class BcSegments {
  get key() {
    if (!this._key) {
      throw new Error('セグメントキーが設定されていないため処理を続行できません。');
    }
    return this.globalSuffix + this._key;
  }

  get year() {
    if (!this._year) {
      throw new Error('入試年度が指定されていないため処理を続行できません。');
    }
    return this._year;
  }



  /**
   * constructor
   */
  constructor(opt = {}) {
    new EventManager(this);

    this.domain        = core.COOKIE_DOMAIN;
    this.expires       = COOKIE_EXPIRES;
    this.state         = 'pending';
    this.globalSuffix  = GLOBAL_SUFFIX;
    this.isProduction  = core.IS_PRODUCTION;
    this.isDevelop     = core.IS_DEVELOP;
    this.watchInterval = WATCH_INTERVAL;
    this._year         = opt.year;
    this._key          = null;
    this._test         = null;
    this.cookies       = cookies;
    this.enabled       = navigator.cookieEnabled;

    // Set Cokkie Manager Defaults
    this.cookies.defaults.domain   = this.domain;
    this.cookies.defaults.expires  = this.expires;
    this.cookies.defaults.path     = '/';
    this.cookies.defaults.secure   = this.isProduction;
    this.cookies.defaults.httponly = false;

    this.path = {
      dir   : core.path.dir,
      script: core.path.script,
      config: core.path.join(core.path.dir, CONFIG_FILE_NAME),
      join  : core.path.join,
    };

    // Set Segments
    segmentClasses.forEach(define => {
      this[define.name] = new define.constructor(this);
    });

    this._init();
  }



  /**
   * fire callback when loaded config
   */
  ready(cb) {
    return new Promise((resolve, reject) => {
      this.hasAndOn('init', () => {
        if (typeof cb === 'function') cb();
        return resolve();
      });
    });
  }



  /**
   * initialize
   */
  _init() {
    return new Promise((resolve, reject) => {
      this._setupVisibilityEvent();
      this._loadConfig()
        .then(config => {
          this._setConfig(config);
          this.state = 'ready';
          this.emit('init');
          return resolve();
        })
        .catch(reject);
    });
  }



  /**
   * load config
   */
  _loadConfig() {
    return new Promise((resolve, reject) => {
      axios({
        method      :'get',
        url         : this.path.config,
        responseType:'json',
      }).then(res => {
        return resolve(res.data);
      }).catch(reject);
    });
  }



  /**
   * set config
   */
  _setConfig(config) {
    this._key  = config.key;

    segmentClasses.forEach(define => {
      if (config[define.name] !== undefined) {
        this[define.name].setConfig(config[define.name]);
      }
    });
  }



  /**
   * set year
   */
  setYear(year) {
    this._year = year;
  }



  _setupVisibilityEvent() {
    let hiddenKey, visibilityChangeKey;

    const handleVisibilityChange = e => {
      if (document[hiddenKey]) {
        this.emit('hide', this);
      } else {
        this.emit('show', this);
      }
    }

    if (document.hidden !== undefined) {
      hiddenKey = 'hidden';
      visibilityChangeKey = 'visibilitychange';
    } else if (document.mozHidden !== undefined) {
      hiddenKey = 'mozHidden';
      visibilityChangeKey = 'mozvisibilitychange';
    } else if (document.msHidden !== undefined) {
      hiddenKey = 'msHidden';
      visibilityChangeKey = 'msvisibilitychange';
    } else if (document.webkitHidden !== undefined) {
      hiddenKey = 'webkitHidden';
      visibilityChangeKey = 'webkitvisibilitychange';
    }

    if (!hiddenKey || document.addEventListener === undefined) {
      console.warn('ブラウザが `Page Visibility API` に対応していないため、リスナの登録をキャンセルします。');
      return;
    }

    document.addEventListener(visibilityChangeKey, handleVisibilityChange, false);
  }
}



// Set For Global
window.BcSegments = BcSegments;



// WEBPACK FOOTER //
// ./src/shared/bc-segments/bc-segments.js